import React, { useEffect, useRef, useState } from "react";
import { Flex, Input, Modal, Select, Spin, message } from "antd";
import heart from "../../../../Assets/Images/heart.png";
import oxygen from "../../../../Assets/Images/Svg/oxygen.svg";
import BP from "../../../../Assets/Icons/vital/BP.svg";
import Bluetooth from "../../../../Assets/Icons/vital/Bluetooth.svg";
import Temp from "../../../../Assets/Icons/vital/Tem.svg";
import TempGraph from "../../../../Assets/Icons/vital/Temgraph.svg";
import BpGraph from "../../../../Assets/Icons/vital/Bpgraph.svg";
import RR from "../../../../Assets/Icons/vital/RR.svg";
import RRGraph from "../../../../Assets/Icons/vital/Rrgraph.svg";
import Pulse from "../../../../Assets/Icons/vital/pulseox.svg";
import PulseGraph from "../../../../Assets/Icons/vital/Pulgraph.svg";
import HRGraph from "../../../../Assets/Icons/vital/HRgraph.svg";
import Height from "../../../../Assets/Icons/vital//Hei.svg";
import HeightGraph from "../../../../Assets/Icons/vital/Heigraph.svg";
import Weight from "../../../../Assets/Icons/vital/wei.svg";
import WeightGraph from "../../../../Assets/Icons/vital/Weigraph.svg";
import BMI from "../../../../Assets/Icons/vital/Bm.svg";
import BMIGraph from "../../../../Assets/Icons/vital/Bmgraph.svg";
import { FiEdit2 } from "react-icons/fi";
import AddVitals from "./Addvitals";
import VitalService from "../../../../Services/VitalService";
import NoDataFound from "../../../../Assets/Images/Svg/nodatafound.svg";
import { convertUTCDateLocal } from "../../../../utils/convertionFunc";
import ViewVital from "./ViewVital";
import VitalChart from "./VitalChart";
import { MdModeEdit } from "react-icons/md";
import VitalGraph from "./vitalGraph";
import Watch from "../../../../Assets/Icons/vital/watch.svg";
import PulseOXChart from "../../Activities/PulseOXChart";
import HeartRateChart from "../../Activities/HeartRateChart";
import RespiratoryChart from "../../Activities/RespiratoryChart";

const months = {
  Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06', Jul: '07',
  Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
};

const PatientVitals = ({ selectedPatient }) => {
  const [vitalsData, setVitalsData] = useState([]);
  const [latestVitalData, setLatestVitalData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedVitalType, setSelectedVitalType] = useState(null);
  const [selectedVitalData, setSelectedVitalData] = useState([]);
  const [vitalCode, setVitalCode] = useState(null);
  const [viewGraph, setViewGraph] = useState(false);
  const [selectedVitalCode, setSelectedVitalCode] = useState("");
  const [vitalName, setVitalName] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [isEditing, setIsEditing] = useState('');
  const [vitalMasterData, setVitalMasterData] = useState([]);
  const [height, setHeight] = useState('');
  const [weight, setWeight] = useState('');
  const [vitalsObj, setVitalsObj] = useState({
    BPS: 0,
    BPD: 0,
    SPO2: 0,
    HR: 0,
    RR: 0,
    TP: 0,
    // BG: 0,
    HI: 0,
    WE: 0,
    BMI: "",
  });
  const [bpValue, setBpValue] = useState("");
  const [showChart, setShowChart] = useState("");
  const [chartModal, setChartModal] = useState(false);
  const activeEditRef = useRef(null);


  useEffect(() => {
    if (!selectedPatient) return;
    const fetchAllData = async () => {
      await Promise.all([VitalMaster(), MyVitalList(), fetchLatestVital()]);
    }
    fetchAllData();
  }, [selectedPatient]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (activeEditRef.current && !activeEditRef.current.contains(event.target)) {
        setIsEditing("");
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const VitalMaster = () => {
    let payload = {
      status: 1,
    };
    VitalService.VitalMasterlist(payload).then((result) => {
      setVitalMasterData(result.data);
    });
  };

  const MyVitalList = async () => {

    let payload = {
      account_Id: selectedPatient?.account_Id,
      // clinic_Id: userData?.user?.clinic_Id,
      patientId: selectedPatient?.patientId,
      status: 1,
    };
    try {
      const response = await VitalService.getVitalsData(payload);
      setVitalsData(response.data);
      if (response.data) {
        // let payload = {
        //   account_Id: selectedPatient?.account_Id,
        //   // clinic_Id: userData?.user?.clinic_Id,
        //   patientId: selectedPatient?.patientId,
        //   fromDate: response.data[0].recordedDateTime,
        //   toDate: response.data[0].recordedDateTime,
        //   status: 1,
        // };
        // const latestVitalsResponse = await VitalService.getSpecificVitalData(
        //   payload
        // );
        // if (latestVitalsResponse.data) {
        //   setLatestVitalData(latestVitalsResponse.data);
        //   latestVitalsResponse.data.filter((vital) => {
        //     if (vital.vitalCode === "HI") {
        //       setHeight(vital.value);
        //     }
        //     else if (vital.vitalCode === "WE") {
        //       setWeight(vital.value);
        //     }
        //   })
        // }
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  const fetchLatestVital = async () => {
    const payload = {
      patientId: selectedPatient?.patientId,
      status: 1
    }
    try {
      const res = await VitalService.getPatientRecentVital(payload);
      setLatestVitalData(res.data || []);
      setHeight(res.data?.find((item) => item.vitalCode === 'HI')?.value || '');
      setWeight(res.data?.find((item) => item.vitalCode === 'WE')?.value || '');
    }
    catch (e) {
      console.log(e);
    }
  }

  const handleVitalUpdate = (value, vitalkey) => {
    const vitalsVal = vitalsObj;
    vitalsVal[vitalkey] = value;
    // console.log('vitalsVal[vitalkey] ', vitalsVal, vitalkey, vitalsObj);

    if (vitalkey === 'Height') {
      handleHeight(value);
      return;
    }
    if (vitalkey === 'Weight') {
      handleWeight(value);
      return;
    }
    setVitalsObj(vitalsVal);
  }


  const handleVitalDateChange = async (value) => {

    let payload = {
      account_Id: selectedPatient?.account_Id,
      clinic_Id: selectedPatient?.clinic_Id,
      patientId: selectedPatient?.patientId,
      fromDate: value,
      toDate: value,
      status: 1,
    };
    setLoading(true)
    await VitalService.getSpecificVitalData(payload)
      .then((result) => {
        console.log(result.data);
        setLatestVitalData(result.data);
      })
      .catch((error) => {
        console.error("Failed to fetch reports:", error);
        setLatestVitalData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updatedVitalsList = async() => {
    try{await fetchLatestVital();}catch(e){console.error(e)}
  };

  const vitalMap = {
    BPS: "Blood Pressure",
    TP: "Temperature",
    HI: "Height",
    WE: "Weight",
    BMI: "BMI",
    HR: "Heart Rate",
    RR: "Respiration Rate",
    PO: "Pulse Oxygen",
    // BG: "Blood Glucose",
  };

  const handleViewAll = (type1, type2) => {
    setSelectedVitalCode(type2 ? `${type1},${type2}` : type1);
    const vital = vitalMap[type1] || null;
    setVitalName(vital);
    setViewModal(true);
  };

  const handleUpdate = async () => {
    const currDate = new Date().toUTCString();
    const dateArr = currDate.split(' ');
    const month = months[dateArr[2]];
    const date = dateArr[1];
    const year = dateArr[3];
    const constructedDate = year + '-' + month + '-' + date;
    const time = dateArr[4];
    const constructedDateTime = constructedDate + " " + time;
    const updatedVitalObj = [];
    const isAllEmpty = Object.values(vitalsObj).every((value) => value === '' || value === 0 || value === null);
    console.log(isAllEmpty);
    if (isAllEmpty) {
      setIsEditing('');
      return;
    }

    const bps = vitalsObj["BPS"];
    const bpd = vitalsObj["BPD"];
    const bpsEmpty = bps === "" || bps === 0 || bps === null;
    const bpdEmpty = bpd === "" || bpd === 0 || bpd === null;

    if ((bpsEmpty && !bpdEmpty) || (!bpsEmpty && bpdEmpty)) {
      message.error("Both Systolic and Diastolic values are required", 4);
      return;
    }

    Object.entries(vitalsObj).forEach(([vitalCode, value]) => {
      if (value !== 0 && value !== '') {
        const changedVitalIndex = latestVitalData.findIndex((vital) => vital.vitalCode === vitalCode);
        if (changedVitalIndex !== -1) {
          latestVitalData[changedVitalIndex].value = value;
          latestVitalData[changedVitalIndex].modifiedDate = constructedDateTime
          updatedVitalObj.push(latestVitalData[changedVitalIndex]);
        }
      }
    });

    console.log(latestVitalData, 'testing ', updatedVitalObj);
    // return;


    await VitalService.updateVital(updatedVitalObj).then((response) => {
      if (response.data[0] === 1) {
        MyVitalList();
        setIsEditing('');
        message.success("Vital Update Successfully", 4);
      }
    })
      .catch((error) => {
        console.error("Error sending data:", error);
        message.error("Failed to update vital", 4);
      });
  }

  const handleHeight = (value) => {
    const newHeight = Number(value);
    setHeight(newHeight);
    if (weight && newHeight) {
      const heightInMeters = Number(newHeight) / 100;
      const bmi = weight / (heightInMeters * heightInMeters);
      const vitalsVal = vitalsObj;
      vitalsVal['BMI'] = bmi.toFixed(1);
    }
  }

  const handleWeight = (value) => {
    const newWeight = Number(value);
    setWeight(newWeight);
    if (height && newWeight) {
      const heightInMeters = Number(height) / 100;
      const bmi = newWeight / (heightInMeters * heightInMeters);
      const vitalsVal = vitalsObj;
      vitalsVal['BMI'] = bmi.toFixed(1);
    }
  }

  const handleGraph = (type, code, data) => {
    setSelectedVitalType(type);
    setSelectedVitalData(data);
    setVitalCode(code);
    setViewGraph(true);
  };

  const handleEditClick = (selectedItem) => {
    setIsEditing(selectedItem);
  };

  const handleClosemodal = () => {
    setIsModalVisible(false);
    MyVitalList();
  };
  const handleCombinedUpdate = (e) => {
    let val = e.target.value.replace(/\D/g, ""); // keep only digits
    if (val.length > 6) val = val.slice(0, 6);  // max 6 digits (3+3)

    // insert slash after 3 digits
    if (val.length > 3) {
      val = val.slice(0, 3) + "/" + val.slice(3);
    }
    setBpValue(val);


    const [sys = "", dia = ""] = val.split("/");
    handleVitalUpdate(sys, "BPS");
    handleVitalUpdate(dia, "BPD");
  }

  const handleTypeCharOpen = (type) => {
    if (type) {
      setShowChart(type);
      setChartModal(true);
    }
  };

  const handleGraphViewClose = () => {
    setChartModal(false);
    setShowChart("");
  }

  return (
    <>
      <div className={`border rounded shadow-md p-2 bg-[#f6f6f6] ${latestVitalData.length === 0 ? 'h-screen' : 'h-[inherit]'}`}>
        <div>
          <div className="w-full flex justify-between items-center">
            <div className="w-full flex items-center justify-end my-6 gap-3">
              <Select
                placeholder="Select Date"
                className="w-56 mx-1"
                defaultValue={vitalsData[0]?.recordedDateTime}
                options={vitalsData?.map((record) => {
                  return {
                    label: convertUTCDateLocal(record.recordedDateTime),
                    value: record.recordedDateTime,
                  };
                })}
                onChange={handleVitalDateChange}
              />
              <button
                type="default"
                onClick={() => {
                  setIsModalVisible(true);
                }}
                className="md:min-w-32 w-[6rem] p-1.5 custom_filter text-brand-White rounded-lg font-semibold"
              >
                Add Vitals
              </button>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="w-full flex items-center justify-center mt-[10%]">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : latestVitalData && latestVitalData.length > 0 ? (
          <>
            <div className="w-full flex gap-7 flex-wrap">
              {/* Blood Pressure */}
              <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col" ref={isEditing === "bloodPressure" ? activeEditRef : null}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={BP} alt="" />
                    <p className="text-sm font-semibold font-sans">
                      Blood Pressure
                    </p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>

                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing === "bloodPressure" ? (
                    // <span className="flex items-center">
                    //   <Input.Group className="">
                    //     <Input
                    //       maxLength={3}
                    //       placeholder="SYS"
                    //       value={sysValue}
                    //       onChange={(e) => handleInputChange(e, "SYS")}
                    //       onBlur={() => handleInputBlur("SYS")}
                    //       className="outline-none border text-center"
                    //       style={{ width: "3rem" }}
                    //     />
                    //     <Input
                    //       maxLength={3}
                    //       placeholder="DIA"
                    //       value={diaValue}
                    //       onChange={(e) => handleInputChange(e, "DIA")}
                    //       onBlur={() => handleInputBlur("DIA")}
                    //       className="outline-none border text-center"
                    //       style={{ width: "3rem" }}
                    //     />
                    //   </Input.Group>
                    // </span>
                    <div className="flex items-center justify-between mt-3">
                      <div className="flex gap-2 items-center justify-between">
                        {/* <div className="flex gap-2">
                          <img src={bp} className="w-7 h-7" alt="Blood Pressure" />
                          <label className="font-semibold text-base">Blood Pressure</label>
                        </div> */}
                        <Input
                          value={bpValue}
                          onChange={handleCombinedUpdate}
                          onBlur={handleUpdate}
                          placeholder="SYS/DIA"
                          className="w-[7rem]"
                          maxLength={7}
                        />
                      </div>
                    </div>
                  ) : (
                    <span>
                      {
                        latestVitalData.filter(
                          (vital) => vital.vitalCode === "BPS"
                        )[0]?.value
                      }
                      /
                      {
                        latestVitalData.filter(
                          (vital) => vital.vitalCode === "BPD"
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500 ml-1">
                    mmHg
                  </span>
                </p>

                <div
                  title="View Graph"
                  className="flex items-center mt-3"
                  onClick={() =>
                    handleGraph("Blood Pressure", "BP", [
                      vitalsData[4],
                      vitalsData[5],
                    ])
                  }
                >
                  {/* <img src={BpGraph} alt="" /> */}
                  <VitalGraph
                    code={"BPS"}
                    color={"#FF9E9E"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    // onClick={() => {
                    //   const bpsData = vitalsData.find(
                    //     (vital) => vital.vitalCode === "BPS"
                    //   );
                    //   const bpdData = vitalsData.find(
                    //     (vital) => vital.vitalCode === "BPD"
                    //   );
                    //   handleEditClick([bpsData, bpdData], "BP");
                    // }}
                    onClick={() => handleEditClick('bloodPressure')}
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("BPS", "BPD")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>

              {/* Temperature */}
              <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col" ref={isEditing === "temp" ? activeEditRef : null}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={Temp} alt="" />
                    <p className="text-sm font-semibold font-sans">
                      Temperature
                    </p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing === "temp" ? (
                    <span>
                      <Input
                        type="text"
                        onChange={(e) => handleVitalUpdate(e.target.value, "TP")}
                        onBlur={handleUpdate}
                        className="w-[4rem]"
                      />
                    </span>
                  ) : (
                    <span>
                      {
                        latestVitalData.filter(
                          (vital) => vital.vitalCode === "TP"
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">°F</span>
                </p>
                <div
                  title="View Graph"
                  onClick={() =>
                    handleGraph("Temperature", "TP", [vitalsData[0]])
                  }
                  className="flex items-center mt-3"
                >
                  {/* <img src={TempGraph} alt="" /> */}
                  <VitalGraph
                    code={"TP"}
                    color={"#24CC8C"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    // onClick={() =>
                    //   handleEditClick(
                    //     vitalsData.filter((vital) => vital.vitalCode === "TP"),
                    //     "TP"
                    //   )
                    // }
                    onClick={() => handleEditClick('temp')}
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("TP")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>

              {/* Respiration Rate */}
              <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col" ref={isEditing === "respiration" ? activeEditRef : null}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={RR} alt="" />
                    <p className="text-sm font-semibold font-sans">
                      Respiration Rate
                    </p>
                  </div>
                  {
                    selectedPatient?.smartWatchUserId ?
                      (
                        <button onClick={() => handleTypeCharOpen("RR")}>
                          <img
                            src={Watch}
                            alt=""
                            className="w-5 h-5 cursor-pointer"
                            title="Click to View Device Data"
                          />
                        </button>
                      )
                      :
                      (
                        <img src={Bluetooth} alt="" />
                      )
                  }

                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing === "respiration" ? (
                    <Input
                      type="text"
                      onChange={(e) => handleVitalUpdate(e.target.value, "RR")}
                      onBlur={handleUpdate}
                      className="w-[4rem]"
                    />
                  ) : (
                    <span>
                      {
                        latestVitalData.filter(
                          (vital) => vital.vitalCode === "RR"
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">rpm</span>
                </p>
                <div
                  title="View Graph"
                  onClick={() =>
                    handleGraph("Respiration Rate", "RR", [vitalsData[8]])
                  }
                  className="flex items-center mt-3"
                >
                  {/* <img src={RRGraph} alt="" /> */}
                  <VitalGraph
                    code={"RR"}
                    color={"#9DCBFF"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    // onClick={() =>
                    //   handleEditClick(
                    //     vitalsData.filter((vital) => vital.vitalCode === "RR"),
                    //     "RR"
                    //   )
                    // }
                    onClick={() => handleEditClick('respiration')}
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("RR")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>

              {/* Pulse Oxygen */}
              <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col" ref={isEditing === "pulse" ? activeEditRef : null}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={Pulse} alt="" />
                    <p className="text-sm font-semibold font-sans">
                      Pulse Oxygen
                    </p>
                  </div>
                  {
                    selectedPatient?.smartWatchUserId ?
                      (
                        <button onClick={() => handleTypeCharOpen("SPO2")}>
                          <img
                            src={Watch}
                            alt=""
                            className="w-5 h-5 cursor-pointer"
                            title="Click to View Device Data"
                          />
                        </button>
                      )
                      :
                      (
                        <img src={Bluetooth} alt="" />
                      )
                  }
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing === "pulse" ? (
                    <Input
                      type="text"
                      onChange={(e) => handleVitalUpdate(e.target.value, "SPO2")}
                      onBlur={handleUpdate}
                      className="w-[4rem]"
                    />
                  ) : (
                    <span>
                      {
                        latestVitalData.filter(
                          (vital) => (vital.vitalCode === "SPO2" || vital.vitalCode === "PO")
                        )[0]?.value
                      }
                    </span>
                  )}

                  <span className="text-sm font-normal text-gray-500">%</span>
                </p>
                <div
                  onClick={() =>
                    handleGraph("Pulse Oxygen", "SPO2", [vitalsData[6]])
                  }
                  className="flex items-center mt-3"
                >
                  {/* <img src={PulseGraph} alt="" /> */}
                  <VitalGraph
                    code={"SPO2"}
                    color={"#A8ECFF"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    // onClick={() =>
                    //   handleEditClick(
                    //     vitalsData.filter((vital) => vital.vitalCode === "PO"),
                    //     "PO"
                    //   )
                    // }
                    onClick={() => handleEditClick('pulse')}
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("SPO2")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>

              {/* Heart rate */}
              <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col" ref={isEditing === "heart" ? activeEditRef : null}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={heart} alt="" className="w-5 h-5" />
                    <p className="text-sm font-semibold font-sans">
                      Heart Rate
                    </p>
                  </div>
                  {
                    selectedPatient?.smartWatchUserId ?
                      (
                        <button onClick={() => handleTypeCharOpen("HR")}>
                          <img
                            src={Watch}
                            alt=""
                            className="w-5 h-5 cursor-pointer"
                            title="Click to View Device Data"
                          />
                        </button>
                      )
                      :
                      (
                        <img src={Bluetooth} alt="" />
                      )
                  }
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing === "heart" ? (
                    <Input
                      type="text"
                      onChange={(e) => handleVitalUpdate(e.target.value, "HR")}
                      onBlur={handleUpdate}
                      className="w-[4rem]"
                    />
                  ) : (
                    <span>
                      {
                        latestVitalData.filter(
                          (vital) => vital.vitalCode === "HR"
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">Bpm</span>
                </p>
                <div
                  onClick={() =>
                    handleGraph("Heart Rate", "HR", [vitalsData[7]])
                  }
                  className="flex items-center mt-3"
                >
                  {/* <img src={HRGraph} alt="" /> */}
                  <VitalGraph
                    code={"HR"}
                    color={"#FFD3B4"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    // onClick={() =>
                    //   handleEditClick(
                    //     vitalsData.filter((vital) => vital.vitalCode === "HR"),
                    //     "HR"
                    //   )
                    // }
                    onClick={() => handleEditClick('heart')}
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("HR")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>

              {/* Blood Glucose */}
              {/* <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col" ref={isEditing === "bloodGlucose" ? activeEditRef : null}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={oxygen} alt="" />
                    <p className="text-sm font-semibold font-sans">
                      Blood Glucose
                    </p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing === "bloodGlucose" ? (
                    <Input
                      type="text"
                      onChange={(e) => handleVitalUpdate(e.target.value, "BG")}
                      onBlur={handleUpdate}
                      className="w-[4rem]"
                    />
                  ) : (
                    <span>
                      {
                        latestVitalData.filter(
                          (vital) => vital.vitalCode === "BG"
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">mg/dL</span>
                </p>
                <div
                  title="View Graph"
                  onClick={() =>
                    handleGraph("Blood Glucose", "BG", [vitalsData[8]])
                  }
                  className="flex items-center mt-3"
                >
                  <VitalGraph
                    code={"BG"}
                    color={"#FFEDC2"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    onClick={() => handleEditClick('bloodGlucose')}
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("BG")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div> */}
            </div>
            <div className="mt-5 flex gap-7">

              {/* Height */}
              <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col" ref={isEditing === "height" ? activeEditRef : null}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={Height} alt="" className="w-5 h-5" />
                    <p className="text-sm font-semibold font-sans">Height</p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing === "height" ? (
                    <Input
                      type="text"
                      onChange={(e) => handleVitalUpdate(e.target.value, "HI")}
                      onBlur={handleUpdate}
                      className="w-[4rem]"
                    />
                  ) : (
                    <span>
                      {
                        latestVitalData.filter(
                          (vital) => vital.vitalCode === "HI"
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">Cm</span>
                </p>
                <div
                  onClick={() => handleGraph("Height", "HI", [vitalsData[1]])}
                  className="flex items-center mt-3"
                >
                  {/* <img src={HeightGraph} alt="" /> */}
                  <VitalGraph
                    code={"HI"}
                    color={"#DDC0FF"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    // onClick={() =>
                    //   handleEditClick(
                    //     vitalsData.filter((vital) => vital.vitalCode === "HI"),
                    //     "HI"
                    //   )
                    // }
                    onClick={() => handleEditClick('height')}
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("HI")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>

              {/* Weight */}
              <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col" ref={isEditing === "weight" ? activeEditRef : null}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={Weight} alt="" className="w-5 h-5" />
                    <p className="text-sm font-semibold font-sans">Weight</p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing === "weight" ? (
                    <>
                      <Input
                        type="text"
                        onChange={(e) => handleVitalUpdate(e.target.value, "WE")}
                        onBlur={handleUpdate}
                        className="w-[4rem]"
                      />
                    </>
                  ) : (
                    <span>
                      {
                        latestVitalData.filter(
                          (vital) => vital.vitalCode === "WE"
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">kg</span>
                </p>
                <div
                  onClick={() => handleGraph("Weight", "WE", [vitalsData[2]])}
                  className="flex items-center mt-3"
                >
                  {/* <img src={WeightGraph} alt="" /> */}
                  <VitalGraph
                    code={"WE"}
                    color={"#FFC0D7"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    // onClick={() =>
                    //   handleEditClick(
                    //     vitalsData.filter((vital) => vital.vitalCode === "WE"),
                    //     "WE"
                    //   )
                    // }
                    onClick={() => handleEditClick('weight')}
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("WE")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>

              {/* BMI */}
              <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={BMI} alt="" className="w-5 h-5" />
                    <p className="text-sm font-semibold font-sans">BMI</p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  <span>
                    {
                      latestVitalData.filter((vital) => vital.vitalCode === "BMI")[0]
                        ?.value
                    }
                  </span>
                  <span className="text-sm font-normal text-gray-500">
                    Kg/m²
                  </span>
                </p>
                <div
                  onClick={() => handleGraph("BMI", "BMI", [vitalsData[3]])}
                  className="flex items-center mt-3"
                >
                  {/* <img src={BMIGraph} alt="" /> */}
                  <VitalGraph
                    code={"BMI"}
                    color={"#FFEDC2"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                {/* <div className="flex justify-between text-xs text-gray-500 mt-1">
                  <span className="text-blue-600 font-medium">M</span>
                  <span>Tu</span>
                  <span>W</span>
                  <span>Th</span>
                  <span>F</span>
                  <span>Sa</span>
                  <span>S</span>
                </div> */}

                <div className="flex items-center justify-between mt-4">
                  <span></span>
                  {/* <FiEdit2 className="text-blue-600 cursor-pointer" /> */}
                  <button
                    onClick={() => handleViewAll("BMI")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="flex h-screen justify-center items-center">
            <div>
              <img src={NoDataFound} alt="No Data" className="w-24 h-24" />
              <p className="text-center ">No Vitals Found</p>
            </div>
          </div>
        )
        }
        {
          isModalVisible && (
            <Modal
              title={<span className="font-bold text-base">Add Vitals</span>}
              open={isModalVisible}
              onOk={() => {
                setIsModalVisible(false);
              }}
              centered={true}
              footer={[]}
              onCancel={() => {
                setIsModalVisible(false);
              }}
              okText="Submit"
              cancelText="Cancel"
              width={800}
              maskClosable={false}
            >
              <AddVitals
                onClose={handleClosemodal}
                updatedVitalsList={updatedVitalsList}
                handleClosemodal={handleClosemodal}
                selectedPatient={selectedPatient}
              />
            </Modal>
          )
        }
      </div >
      {viewModal && (
        <Modal
          title={`Vitals - ${vitalName}`}
          visible={viewModal}
          onOk={() => {
            setViewModal(false);
          }}
          centered={true}
          footer={null}
          onCancel={() => {
            setViewModal(false);
          }}
          okText="Submit"
          cancelText="Cancel"
          width={400}
          maskClosable={false}
          destroyOnClose
        >
          <ViewVital
            selectedVitalCode={selectedVitalCode}
            vitalName={vitalName}
            onClose={() => handleClosemodal()}
          />
        </Modal>
      )}

      {/* Vital 1D/7D chart */}
      <Modal
        title={`${selectedVitalType} Graph`}
        open={viewGraph}
        onCancel={() => setViewGraph(false)}
        footer={[]}
        destroyOnClose
        width={"40%"}
        height={"500px"}
      >
        <VitalChart
          selectedVital={vitalCode}
          selectedPatient={selectedPatient}
        />
      </Modal>

      <Modal
        open={chartModal}
        onCancel={handleGraphViewClose}
        footer={[]}
        width={900}
        title={showChart}
        destroyOnClose
      >
        {showChart === "SPO2" && <PulseOXChart smartWatchId={selectedPatient?.smartWatchUserId} />}
        {showChart === "HR" && <HeartRateChart smartWatchId={selectedPatient?.smartWatchUserId} />}
        {showChart === "RR" && <RespiratoryChart smartWatchId={selectedPatient?.smartWatchUserId} />}
      </Modal>
    </>

  );
};

export default PatientVitals;

// import { useEffect, useState } from "react";
// import { Input, Modal, Select, Spin, message } from "antd";
// import AddVitals from "./Addvitals";
// import NoDataFound from "../../../../Assets/Images/Svg/nodatafound.svg";
// import ViewVital from "./ViewVital";
// import VitalChart from "./VitalChart";
// import moment from "moment";
// import { LoadingOutlined } from "@ant-design/icons";
// import { FiEdit2 } from "react-icons/fi";
// import {
//   Area,
//   AreaChart,
//   ResponsiveContainer,
//   Tooltip,
//   XAxis,
//   YAxis,
// } from "recharts";
// import dayjs from "dayjs";
// import Watch from "../../../../Assets/Icons/vital/watch.svg";
// import PulseOXChart from "../../Activities/PulseOXChart";
// import HeartRateChart from "../../Activities/HeartRateChart";
// import RespiratoryChart from "../../Activities/RespiratoryChart";
// import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
// import VitalService from "../../../../Services/VitalService";
// import heart from "../../../../Assets/Images/heart.png";
// import oxygen from "../../../../Assets/Images/Svg/oxygen.svg";
// import BP from "../../../../Assets/Icons/vital/BP.svg";
// import Bluetooth from "../../../../Assets/Icons/vital/Bluetooth.svg";
// import Temp from "../../../../Assets/Icons/vital/Tem.svg";
// import TempGraph from "../../../../Assets/Icons/vital/Temgraph.svg";
// import BpGraph from "../../../../Assets/Icons/vital/Bpgraph.svg";
// import RR from "../../../../Assets/Icons/vital/RR.svg";
// import RRGraph from "../../../../Assets/Icons/vital/Rrgraph.svg";
// import Pulse from "../../../../Assets/Icons/vital/pulseox.svg";
// import PulseGraph from "../../../../Assets/Icons/vital/Pulgraph.svg";
// import HRGraph from "../../../../Assets/Icons/vital/HRgraph.svg";
// import Height from "../../../../Assets/Icons/vital//Hei.svg";
// import HeightGraph from "../../../../Assets/Icons/vital/Heigraph.svg";
// import Weight from "../../../../Assets/Icons/vital/wei.svg";
// import WeightGraph from "../../../../Assets/Icons/vital/Weigraph.svg";
// import BMI from "../../../../Assets/Icons/vital/Bm.svg";
// import BMIGraph from "../../../../Assets/Icons/vital/Bmgraph.svg";
// dayjs.extend(isSameOrBefore);

// const PatientVitals = ({ selectedPatient }) => {
//   const [vitalsData, setVitalsData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [viewGraph, setViewGraph] = useState(false);
//   const [viewModal, setViewModal] = useState(false);
//   const [selectedVitalCode, setSelectedVitalCode] = useState("");
//   const [vitalName, setVitalName] = useState("");
//   const [isEditing, setIsEditing] = useState("");
//   const [editedValue, setEditedValue] = useState();
//   const [sysValue, setSysValue] = useState("");
//   const [diaValue, setDiaValue] = useState("");
//   const [vital, setVital] = useState([null, null]);
//   const [vitalCode, setVitalCode] = useState(null);
//   const [hasBlurredSYS, setHasBlurredSYS] = useState(false);
//   const [hasBlurredDIA, setHasBlurredDIA] = useState(false);
//   const [vitalList, setVitalList] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const loadingIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;
//   const [showChart, setShowChart] = useState("");
//   const [chartModal, setChartModal] = useState(false);
//   const [selectedVitalType, setSelectedVitalType] = useState(null);
//   const [selectedVitalData, setSelectedVitalData] = useState([]);

//   const onChartClose = () => {
//     setShowChart("");
//     setChartModal(false);
//   };

//   const handleTypeCharOpen = (type) => {
//     if (type) {
//       setShowChart(type);
//       setChartModal(true);
//     }
//   };

//   useEffect(() => {
//     vitalalldata();
//   }, [selectedPatient]);

//   const handleClosemodal = () => {
//     setIsModalVisible(false);
//     vitalalldata();
//   };
//   const handleGraph = (type, code, data) => {
//     setSelectedVitalType(type);
//     setSelectedVitalData(data);
//     setVitalCode(code);
//     setViewGraph(true);
//   };
//   const convertUTCDateLocal = (utcDate, format) => {
//     if (!format) {
//       format = "DD/MM/YYYY, HH:mm:ss";
//     }
//     const localDate = moment.utc(utcDate).local();
//     return localDate.format(format);
//   };

//   const handleEditClick = (vitalData, key) => {
//     setIsEditing(key);

//     if (key === "BP") {
//       const systolicVital = vitalData.find(
//         (vital) => vital.vitalCode === "BPS"
//       );
//       const diastolicVital = vitalData.find(
//         (vital) => vital.vitalCode === "BPD"
//       );

//       setSysValue(systolicVital?.value || "");
//       setDiaValue(diastolicVital?.value || "");

//       setVital([systolicVital, diastolicVital]);
//     } else {
//       setEditedValue(vitalData[0]?.value || "");
//       setVital(vitalData);
//     }
//   };

//   const handleInputChange = (event, type) => {
//     if (type === "SYS") setSysValue(event.target.value);
//     else if (type === "DIA") setDiaValue(event.target.value);
//     else setEditedValue(event.target.value);
//   };

//   const handleInputBlur = (type) => {
//     if (type === "SYS") setHasBlurredSYS(true);
//     else if (type === "DIA") setHasBlurredDIA(true);

//     if (isEditing === "BP" && hasBlurredSYS && hasBlurredDIA) {
//       if (sysValue && diaValue) {
//         const updatedSystolic = {
//           ...vital[0],
//           value: sysValue,
//           account_Id: selectedPatient?.account_Id,
//           clinic_Id: selectedPatient?.clinic_Id,
//         };

//         const updatedDiastolic = {
//           ...vital[1],
//           value: diaValue,
//           account_Id: selectedPatient?.account_Id,
//           clinic_Id: selectedPatient?.clinic_Id,
//         };

//         const payload = [updatedSystolic, updatedDiastolic];

//         VitalService.updateVital(payload)
//           .then((response) => {
//             vitalalldata();
//             message.success("Blood Pressure Updated Successfully", 4);
//           })
//           .catch((error) => {
//             console.error("Error sending data:", error);
//             message.error("Failed to update blood pressure", 4);
//           });

//         setHasBlurredSYS(false);
//         setHasBlurredDIA(false);
//         setIsEditing(false);
//       }
//     } else if (isEditing !== "BP" && editedValue) {
//       const updatedVital = {
//         ...vital[0],
//         value: editedValue,
//         account_Id: selectedPatient?.account_Id,
//         clinic_Id: selectedPatient?.clinic_Id,
//       };

//       const payload = [updatedVital];

//       VitalService.updateVital(payload)
//         .then((response) => {
//           vitalalldata();
//           message.success("Vital Updated Successfully", 4);
//         })
//         .catch((error) => {
//           console.error("Error sending data:", error);
//           message.error("Failed to update vital", 4);
//         });
//       setIsEditing(false);
//     }
//   };
//   const handleVitalDateChange = (value) => {
//     setSelectedDate(value);
//     MyVitalList(value);
//   };
//   const vitalalldata = async (value) => {
//     let payload = {
//       patientId: selectedPatient?.patientId,
//       status: 1,
//     };
//     await VitalService.getVitalsData(payload)
//       .then((result) => {
//         setVitalList(result.data);
//         if (result.data && result.data.length > 0) {
//           const defaultDate = result.data[0]?.recordedDateTime;
//           setSelectedDate(defaultDate);
//           MyVitalList(defaultDate);
//         } else {
//           setVitalsData([]);
//         }
//       })
//       .catch((error) => {
//         console.error("Failed to fetch reports:", error);
//         setVitalList([]);
//       });
//   };

//   const MyVitalList = (values) => {
//     setLoading(true);
//     let payload = {
//       patientId: selectedPatient?.patientId,
//       fromDate: values,
//       toDate: values,
//     };
//     VitalService.getSpecificVitalData(payload)
//       .then((result) => {
//         setVitalsData(result?.data);
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };
//   const updatedVitalsList = (data) => {
//     setVitalsData(data);
//   };
//   const handleViewAll = (type1, type2) => {
//     setSelectedVitalCode(`${type1},${type2}`);
//     const vital =
//       type1 === "BPS"
//         ? "Blood Pressure"
//         : type1 === "TP"
//         ? "Temperature"
//         : type1 === "HI"
//         ? "Height"
//         : type1 === "WE"
//         ? "Weight"
//         : type1 === "BMI"
//         ? "BMI"
//         : type1 === "HR"
//         ? "Heart Rate"
//         : type1 === "RR"
//         ? "Respiration Rate"
//         : type1 === "SPO2"
//         ? "Pulse Oxygen"
//         : null;
//     setVitalName(vital);
//     setViewModal(true);
//   };

//   return (
//     <div className="p-5 w-[95%] m-auto">
//       <div>
//         <div className="flex justify-between my-3">
//           <h2 className="font-bold text-lg font-sans text-primaryColor">
//             My Vitals
//           </h2>
//           <div className="flex gap-2 mb-3">
//             <Select
//               placeholder="Select Date"
//               className="w-56 h-9 mx-1"
//               // value={selectedDate}
//               options={vitalList?.map((record) => {
//                 return {
//                   label: convertUTCDateLocal(record?.recordedDateTime),
//                   value: record?.recordedDateTime,
//                 };
//               })}
//               onChange={handleVitalDateChange}
//             />
//             <button
//               type="default"
//               onClick={() => {
//                 setIsModalVisible(true);
//               }}
//               className=" rounded-md text-white px-4"
//             >
//               Add Vitals
//             </button>
//           </div>
//         </div>
//       </div>

//       {loading ? (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             height: "60vh",
//             width: "100%",
//           }}
//         >
//           <Spin indicator={loadingIcon} size="large" />
//         </div>
//       ) : !loading && vitalsData && vitalsData.length > 0 ? (
//         <>
//           <div className="flex gap-7 w-full">
//             <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col">
//               <div className="flex items-center justify-between mb-2">
//                 <div className="flex items-center gap-2">
//                   <img src={BP} alt="" />
//                   <p className="text-sm font-semibold font-sans">
//                     Blood Pressure
//                   </p>
//                 </div>
//                 <img src={Bluetooth} alt="" />
//               </div>

//               <p className="text-base font-sans font-bold mt-2">
//                 {isEditing == "BP" ? (
//                   <span className="flex items-center">
//                     <Input.Group className="">
//                       <Input
//                         maxLength={3}
//                         placeholder="SYS"
//                         value={sysValue}
//                         onChange={(e) => handleInputChange(e, "SYS")}
//                         onBlur={() => handleInputBlur("SYS")}
//                         className="outline-none border text-center"
//                         style={{ width: "3rem" }}
//                       />
//                       <Input
//                         maxLength={3}
//                         placeholder="DIA"
//                         value={diaValue}
//                         onChange={(e) => handleInputChange(e, "DIA")}
//                         onBlur={() => handleInputBlur("DIA")}
//                         className="outline-none border text-center"
//                         style={{ width: "3rem" }}
//                       />
//                     </Input.Group>
//                   </span>
//                 ) : (
//                   <span>
//                     {
//                       vitalsData.filter((vital) => vital.vitalCode === "BPS")[0]
//                         ?.value
//                     }
//                     /
//                     {
//                       vitalsData.filter((vital) => vital.vitalCode === "BPD")[0]
//                         ?.value
//                     }
//                   </span>
//                 )}
//                 <span className="text-sm font-normal text-gray-500 ml-1">
//                   mmHg
//                 </span>
//               </p>

//               <div
//                 title="View Graph"
//                 className="flex items-center mt-3"
//                 onClick={() =>
//                   handleGraph("Blood Pressure", "BP", [
//                     vitalsData[4],
//                     vitalsData[5],
//                   ])
//                 }
//               >
//                 <Graph
//                   code={"BPS"}
//                   color={"#FF9E9E"}
//                   patientId={selectedPatient?.patientId}
//                 />
//               </div>

//               <div className="flex items-center justify-between mt-4">
//                 <FiEdit2
//                   onClick={() => {
//                     const bpsData = vitalsData.find(
//                       (vital) => vital.vitalCode === "BPS"
//                     );
//                     const bpdData = vitalsData.find(
//                       (vital) => vital.vitalCode === "BPD"
//                     );
//                     handleEditClick([bpsData, bpdData], "BP");
//                   }}
//                   className="text-blue-600 cursor-pointer"
//                 />
//                 <button
//                   onClick={() => handleViewAll("BPS", "BPD")}
//                   className="text-blue-600 bg-white text-sm font-bold underline font-sans"
//                 >
//                   View all
//                 </button>
//               </div>
//             </div>
//             <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col">
//               <div className="flex items-center justify-between mb-2">
//                 <div className="flex items-center gap-2">
//                   <img src={Temp} alt="" />
//                   <p className="text-sm font-semibold font-sans">Temperature</p>
//                 </div>
//                 <img src={Bluetooth} alt="" />
//               </div>
//               <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
//                 {isEditing == "TP" ? (
//                   <span>
//                     <Input
//                       type="text"
//                       value={editedValue}
//                       onChange={handleInputChange}
//                       onBlur={handleInputBlur}
//                       className="w-[4rem]"
//                     />
//                   </span>
//                 ) : (
//                   <span>
//                     {
//                       vitalsData.filter((vital) => vital.vitalCode === "TP")[0]
//                         ?.value
//                     }
//                   </span>
//                 )}
//                 <span className="text-sm font-normal text-gray-500">°F</span>
//               </p>
//               <div
//                 title="View Graph"
//                 onClick={() =>
//                   handleGraph("Temperature", "TP", [vitalsData[0]])
//                 }
//                 className="flex items-center mt-3"
//               >
//                 <Graph
//                   code={"TP"}
//                   color={"#24CC8C"}
//                   patientId={selectedPatient?.patientId}
//                 />{" "}
//               </div>

//               <div className="flex items-center justify-between mt-4">
//                 <FiEdit2
//                   onClick={() =>
//                     handleEditClick(
//                       vitalsData.filter((vital) => vital.vitalCode === "TP"),
//                       "TP"
//                     )
//                   }
//                   className="text-blue-600 cursor-pointer"
//                 />
//                 <button
//                   onClick={() => handleViewAll("TP")}
//                   className="text-blue-600 bg-white text-sm font-bold underline font-sans"
//                 >
//                   View all
//                 </button>
//               </div>
//             </div>
//             <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col">
//               <div className="flex items-center justify-between mb-2">
//                 <div className="flex items-center gap-2">
//                   <img src={RR} alt="" />
//                   <p className="text-sm font-semibold font-sans">
//                     Respiration Rate
//                   </p>
//                 </div>
//                 {selectedPatient.smartWatchUserId && (
//                   <div onClick={() => handleTypeCharOpen("RR")}>
//                     <img
//                       src={Watch}
//                       alt=""
//                       className="w-5 h-5 cursor-pointer"
//                       title="Click to View Device Data"
//                     />
//                   </div>
//                 )}
//               </div>

//               <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
//                 {isEditing == "RR" ? (
//                   <Input
//                     type="text"
//                     value={editedValue}
//                     onChange={handleInputChange}
//                     onBlur={handleInputBlur}
//                     className="w-[4rem]"
//                   />
//                 ) : (
//                   <span>
//                     {
//                       vitalsData.filter((vital) => vital.vitalCode === "RR")[0]
//                         ?.value
//                     }
//                   </span>
//                 )}
//                 <span className="text-sm font-normal text-gray-500">rpm</span>
//               </p>
//               <div
//                 title="View Graph"
//                 onClick={() =>
//                   handleGraph("Respiration Rate", "RR", [vitalsData[8]])
//                 }
//                 className="flex items-center mt-3"
//               >
//                 <Graph
//                   code={"RR"}
//                   color={"#9DCBFF"}
//                   patientId={selectedPatient?.patientId}
//                 />{" "}
//               </div>

//               <div className="flex items-center justify-between mt-4">
//                 <FiEdit2
//                   onClick={() =>
//                     handleEditClick(
//                       vitalsData.filter((vital) => vital.vitalCode === "RR"),
//                       "RR"
//                     )
//                   }
//                   className="text-blue-600 cursor-pointer"
//                 />
//                 <button
//                   onClick={() => handleViewAll("RR")}
//                   className="text-blue-600 bg-white text-sm font-bold underline font-sans"
//                 >
//                   View all
//                 </button>
//               </div>
//             </div>
//             <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col">
//               <div className="flex items-center justify-between mb-2">
//                 <div className="flex items-center gap-2">
//                   <img src={Pulse} alt="" />
//                   <p className="text-sm font-semibold font-sans">
//                     Pulse Oxygen
//                   </p>
//                 </div>
//                 {selectedPatient.smartWatchUserId && (
//                   <div onClick={() => handleTypeCharOpen("SPO2")}>
//                     <img
//                       src={Watch}
//                       alt=""
//                       className="w-5 h-5 cursor-pointer"
//                       title="Click to View Device Data"
//                     />
//                   </div>
//                 )}
//               </div>
//               <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
//                 {isEditing == "SPO2" ? (
//                   <Input
//                     type="text"
//                     value={editedValue}
//                     onChange={handleInputChange}
//                     onBlur={handleInputBlur}
//                     className="w-[4rem]"
//                   />
//                 ) : (
//                   <span>
//                     {
//                       vitalsData.filter(
//                         (vital) => vital.vitalCode === "SPO2"
//                       )[0]?.value
//                     }
//                   </span>
//                 )}

//                 <span className="text-sm font-normal text-gray-500">%</span>
//               </p>
//               <div
//                 onClick={() =>
//                   handleGraph("Pulse Oxygen", "SPO2", [vitalsData[6]])
//                 }
//                 className="flex items-center mt-3"
//               >
//                 <Graph
//                   code={"SPO2"}
//                   color={"#A8ECFF"}
//                   patientId={selectedPatient?.patientId}
//                 />{" "}
//               </div>

//               <div className="flex items-center justify-between mt-4">
//                 <FiEdit2
//                   onClick={() =>
//                     handleEditClick(
//                       vitalsData.filter((vital) => vital.vitalCode === "SPO2"),
//                       "SPO2"
//                     )
//                   }
//                   className="text-blue-600 cursor-pointer"
//                 />
//                 <button
//                   onClick={() => handleViewAll("SPO2")}
//                   className="text-blue-600 bg-white text-sm font-bold underline font-sans"
//                 >
//                   View all
//                 </button>
//               </div>
//             </div>
//             <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col">
//               <div className="flex items-center justify-between mb-2">
//                 <div className="flex items-center gap-2">
//                   <img src={heart} alt="" className="w-5 h-5" />
//                   <p className="text-sm font-semibold font-sans">Heart Rate</p>
//                 </div>
//                 {selectedPatient.smartWatchUserId && (
//                   <div onClick={() => handleTypeCharOpen("HR")}>
//                     <img
//                       src={Watch}
//                       alt=""
//                       className="w-5 h-5 cursor-pointer"
//                       title="Click to View Device Data"
//                     />
//                   </div>
//                 )}
//               </div>
//               <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
//                 {isEditing == "HR" ? (
//                   <Input
//                     type="text"
//                     value={editedValue}
//                     onChange={handleInputChange}
//                     onBlur={handleInputBlur}
//                     className="w-[4rem]"
//                   />
//                 ) : (
//                   <span>
//                     {
//                       vitalsData.filter((vital) => vital.vitalCode === "HR")[0]
//                         ?.value
//                     }
//                   </span>
//                 )}
//                 <span className="text-sm font-normal text-gray-500">Bpm</span>
//               </p>
//               <div
//                 onClick={() => handleGraph("Heart Rate", "HR", [vitalsData[7]])}
//                 className="flex items-center mt-3"
//               >
//                 <Graph
//                   code={"HR"}
//                   color={"#FFD3B4"}
//                   patientId={selectedPatient?.patientId}
//                 />{" "}
//               </div>

//               <div className="flex items-center justify-between mt-4">
//                 <FiEdit2
//                   onClick={() =>
//                     handleEditClick(
//                       vitalsData.filter((vital) => vital.vitalCode === "HR"),
//                       "HR"
//                     )
//                   }
//                   className="text-blue-600 cursor-pointer"
//                 />
//                 <button
//                   onClick={() => handleViewAll("HR")}
//                   className="text-blue-600 bg-white text-sm font-bold underline font-sans"
//                 >
//                   View all
//                 </button>
//               </div>
//             </div>
//           </div>
//           <div className="mt-5 flex gap-7">
//             <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col">
//               <div className="flex items-center justify-between mb-2">
//                 <div className="flex items-center gap-2">
//                   <img src={Height} alt="" className="w-5 h-5" />
//                   <p className="text-sm font-semibold font-sans">Height</p>
//                 </div>
//                 <img src={Bluetooth} alt="" />
//               </div>
//               <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
//                 {isEditing == "HI" ? (
//                   <Input
//                     type="text"
//                     value={editedValue}
//                     onChange={handleInputChange}
//                     onBlur={handleInputBlur}
//                     className="w-[4rem]"
//                   />
//                 ) : (
//                   <span>
//                     {
//                       vitalsData.filter((vital) => vital.vitalCode === "HI")[0]
//                         ?.value
//                     }
//                   </span>
//                 )}
//                 <span className="text-sm font-normal text-gray-500">Cm</span>
//               </p>
//               <div
//                 onClick={() => handleGraph("Height", "HI", [vitalsData[1]])}
//                 className="flex items-center mt-3"
//               >
//                 <Graph
//                   code={"HI"}
//                   color={"#DDC0FF"}
//                   patientId={selectedPatient?.patientId}
//                 />{" "}
//               </div>

//               <div className="flex items-center justify-between mt-4">
//                 <FiEdit2
//                   onClick={() =>
//                     handleEditClick(
//                       vitalsData.filter((vital) => vital.vitalCode === "HI"),
//                       "HI"
//                     )
//                   }
//                   className="text-blue-600 cursor-pointer"
//                 />
//                 <button
//                   onClick={() => handleViewAll("HI")}
//                   className="text-blue-600 bg-white text-sm font-bold underline font-sans"
//                 >
//                   View all
//                 </button>
//               </div>
//             </div>
//             <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col">
//               <div className="flex items-center justify-between mb-2">
//                 <div className="flex items-center gap-2">
//                   <img src={Weight} alt="" className="w-5 h-5" />
//                   <p className="text-sm font-semibold font-sans">Weight</p>
//                 </div>
//                 <img src={Bluetooth} alt="" />
//               </div>
//               <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
//                 {isEditing == "WE" ? (
//                   <>
//                     <Input
//                       type="text"
//                       value={editedValue}
//                       onChange={handleInputChange}
//                       onBlur={handleInputBlur}
//                       className="w-[4rem]"
//                     />
//                   </>
//                 ) : (
//                   <span>
//                     {
//                       vitalsData.filter((vital) => vital.vitalCode === "WE")[0]
//                         ?.value
//                     }
//                   </span>
//                 )}
//                 <span className="text-sm font-normal text-gray-500">kg</span>
//               </p>
//               <div
//                 onClick={() => handleGraph("Weight", "WE", [vitalsData[2]])}
//                 className="flex items-center mt-3"
//               >
//                 <Graph
//                   code={"WE"}
//                   color={"#FFC0D7"}
//                   patientId={selectedPatient?.patientId}
//                 />{" "}
//               </div>

//               <div className="flex items-center justify-between mt-4">
//                 <FiEdit2
//                   onClick={() =>
//                     handleEditClick(
//                       vitalsData.filter((vital) => vital.vitalCode === "WE"),
//                       "WE"
//                     )
//                   }
//                   className="text-blue-600 cursor-pointer"
//                 />
//                 <button
//                   onClick={() => handleViewAll("WE")}
//                   className="text-blue-600 bg-white text-sm font-bold underline font-sans"
//                 >
//                   View all
//                 </button>
//               </div>
//             </div>
//             <div className="w-52 rounded-xl border bg-white shadow-sm p-4 flex flex-col">
//               <div className="flex items-center justify-between mb-2">
//                 <div className="flex items-center gap-2">
//                   <img src={BMI} alt="" className="w-5 h-5" />
//                   <p className="text-sm font-semibold font-sans">BMI</p>
//                 </div>
//                 <img src={Bluetooth} alt="" />
//               </div>
//               <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
//                 <span>
//                   {
//                     vitalsData.filter((vital) => vital.vitalCode === "BMI")[0]
//                       ?.value
//                   }
//                 </span>
//                 <span className="text-sm font-normal text-gray-500">Kg/m²</span>
//               </p>
//               <div
//                 onClick={() => handleGraph("BMI", "BMI", [vitalsData[3]])}
//                 className="flex items-center mt-3"
//               >
//                 <Graph
//                   code={"BMI"}
//                   color={"#FFEDC2"}
//                   patientId={selectedPatient?.patientId}
//                 />
//               </div>

//               <div className="flex items-center justify-between mt-4">
//                 <span></span>
//                 <button
//                   onClick={() => handleViewAll("BMI")}
//                   className="text-blue-600 bg-white text-sm font-bold underline font-sans"
//                 >
//                   View all
//                 </button>
//               </div>
//             </div>
//           </div>
//         </>
//       ) : (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             flexDirection: "column",
//             padding: "20px",
//             borderRadius: "8px",
//             color: "#595959",
//             height: "200px",
//             textAlign: "center",
//             width: "100%",
//           }}
//         >
//           <p style={{ fontSize: "18px", fontWeight: "bold" }}>
//             No Vitals data found
//           </p>
//           <img src={NoDataFound} alt="No data" />
//         </div>
//       )}

//       {isModalVisible && (
//         <Modal
//           title={<span className="text-lg font-semibold">Vitals</span>}
//           visible={isModalVisible}
//           onOk={() => {
//             setIsModalVisible(false);
//           }}
//           centered={true}
//           footer={null}
//           onCancel={() => {
//             setIsModalVisible(false);
//           }}
//           okText="Submit"
//           cancelText="Cancel"
//           width={650}
//           maskClosable={false}
//         >
//           <AddVitals
//             onClose={handleClosemodal}
//             updatedVitalsList={updatedVitalsList}
//           />
//         </Modal>
//       )}

//       {viewGraph && (
//         <VitalChart
//           title={`${selectedVitalType} Graph`}
//           data={selectedVitalCode}
//           type={selectedVitalType}
//           vitalCode={vitalCode}
//           closePopup={() => setViewGraph(false)}
//         />
//       )}

//       {viewModal && (
//         <Modal
//           title={`Vitals - ${vitalName}`}
//           visible={viewModal}
//           onOk={() => {
//             setViewModal(false);
//           }}
//           centered={true}
//           footer={null}
//           onCancel={() => {
//             setViewModal(false);
//           }}
//           okText="Submit"
//           cancelText="Cancel"
//           // width={400}
//           maskClosable={false}
//         >
//           <ViewVital
//             selectedVitalCode={selectedVitalCode}
//             vitalName={vitalName}
//             onClose={() => handleClosemodal()}
//           />
//         </Modal>
//       )}

//       <Modal
//         open={chartModal}
//         onCancel={onChartClose}
//         footer={null}
//         width={900}
//         title={showChart}
//         destroyOnClose
//       >
//         {showChart == "SPO2" && (
//           <PulseOXChart smartWatchId={selectedPatient?.smartWatchUserId} />
//         )}
//         {showChart == "HR" && (
//           <HeartRateChart smartWatchId={selectedPatient?.smartWatchUserId} />
//         )}
//         {showChart == "RR" && (
//           <RespiratoryChart smartWatchId={selectedPatient?.smartWatchUserId} />
//         )}
//       </Modal>
//     </div>
//   );
// };

// const Graph = ({ code, color, patientId }) => {
//   const [chartData, setChartData] = useState([]);

//   const CustomTooltip = ({ active, payload }) => {
//     if (active && payload && payload.length) {
//       const data = payload[0]?.payload;

//       if (!data) return null;

//       const hasDual = data.data1 != null || data.data2 != null;
//       const valueText = hasDual
//         ? `${data.data1 ?? "-"}${data.data2 ? ` / ${data.data2}` : ""}`
//         : data.uv ?? "-";

//       return (
//         <div
//           style={{
//             backgroundColor: "#fff",
//             border: "1px solid #ccc",
//             padding: "8px",
//             borderRadius: "4px",
//             color: "#333",
//             fontSize: "12px",
//           }}
//         >
//           <p style={{ margin: 0, fontWeight: "bold" }}>
//             {dayjs(data.date).format("dddd, YYYY-MM-DD")}
//           </p>

//           <p style={{ margin: 0, color: "#FB7185" }}>Value: {valueText}</p>
//         </div>
//       );
//     }

//     return null;
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       const result = await getVitalsForGraph(code);
//       setChartData(result);
//     };
//     fetchData();
//   }, [code]);

//   const getVitalsForGraph = async (code) => {
//     const fromDate = dayjs().subtract(7, "day").startOf("day");
//     const toDate = dayjs().endOf("day");

//     const vitalCodes = code === "BPS" ? ["BPS", "BPD"] : [code];

//     const payload = {
//       patientId,
//       vitalCodes,
//       fromDate: fromDate.format("YYYY-MM-DD HH:mm:ss"),
//       toDate: toDate.format("YYYY-MM-DD HH:mm:ss"),
//     };

//     const result = await VitalService.getAllVitalsData(payload);

//     const valuesByCode = {};

//     (result?.data || [])
//       .filter((item) => item.value && item.value !== 0 && item.value !== "0")
//       .forEach((item) => {
//         const key = dayjs(item.recordedDateTime).format("YYYY-MM-DD");
//         const vitalCode = item.vitalCode;
//         if (!valuesByCode[vitalCode]) valuesByCode[vitalCode] = {};
//         valuesByCode[vitalCode][key] = item.value;
//       });

//     const data = [];
//     let current = fromDate;
//     while (current.isSameOrBefore(toDate, "day")) {
//       const dateKey = current.format("YYYY-MM-DD");
//       data.push({
//         day: current.format("dd")[0],
//         date: dateKey,
//         data1: valuesByCode["BPS"]?.[dateKey] ?? null,
//         data2: valuesByCode["BPD"]?.[dateKey] ?? null,
//         uv: valuesByCode[code]?.[dateKey] ?? null,
//       });
//       current = current.add(1, "day");
//     }

//     return data;
//   };

//   const handleAreaClick = (e) => {
//     if (e && e.activePayload && e.activePayload[0]) {
//       const clickedData = e.activePayload[0].payload;
//     }
//   };
//   return (
//     <div className="w-full h-[100px] flex items-center justify-center">
//       {chartData?.length > 0 ? (
//         <ResponsiveContainer width="100%" height={100}>
//           <AreaChart data={chartData} onClick={handleAreaClick}>
//             <defs>
//               <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
//                 <stop offset="5%" stopColor={color} stopOpacity={0.8} />
//                 <stop offset="95%" stopColor={color} stopOpacity={0} />
//               </linearGradient>
//             </defs>
//             <XAxis
//               dataKey="day"
//               axisLine={false}
//               tickLine={false}
//               tick={{ fill: "#374151", fontSize: 10, fontWeight: 300 }}
//             />
//             <YAxis hide />
//             <Tooltip content={<CustomTooltip />} />
//             <Area
//               type="basis"
//               dataKey="uv"
//               stroke={color}
//               strokeWidth={2}
//               fill={color}
//               fillOpacity={0.2}
//               connectNulls={true}
//               dot={(props) => {
//                 if (props.payload.uv != null) {
//                   return (
//                     <circle
//                       cx={props.cx}
//                       cy={props.cy}
//                       r={4} // size of the dot
//                       fill={color} // dot color
//                       stroke="#fff" // outline
//                       strokeWidth={1}
//                     />
//                   );
//                 }
//                 return null;
//               }}
//             />
//             <Area
//               type="basis"
//               dataKey="data2"
//               stroke="#82ca9d"
//               strokeWidth={2}
//               fill={"#82ca9d"}
//               fillOpacity={0.3}
//               connectNulls
//               dot={(props) =>
//                 props.payload.data2 != null ? (
//                   <circle
//                     cx={props.cx}
//                     cy={props.cy}
//                     r={4}
//                     fill="#82ca9d"
//                     stroke="#fff"
//                     strokeWidth={1}
//                   />
//                 ) : null
//               }
//             />
//           </AreaChart>
//         </ResponsiveContainer>
//       ) : (
//         <div className="flex items-center justify-center w-full h-full">
//           <div className="w-full h-[100px] bg-gray-200 rounded-md animate-pulse" />
//         </div>
//       )}
//     </div>
//   );
// };

// export default PatientVitals;
